export class TimerService {
  delay: number = 0; // in ms
  private _elapsedTime: number = 0; // in ms
  private finished: boolean = false;
  private startTimestamp: number | undefined = undefined;
  private rafId: number | null = null;
  private listeners: Array<(elapsed: number) => void> = [];

  subscribe(listener: (elapsed: number) => void) {
    this.listeners.push(listener);
  }

  unsubscribe(listener: (elapsed: number) => void) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  pause() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if (this.startTimestamp !== undefined) {
      this._elapsedTime += Date.now() - this.startTimestamp;
      this.startTimestamp = undefined;
    }
  }

  resume() {
    if (this.isStarted) return;
    if (this.delay !== null && this.delay !== undefined && !this.finished) {
      this.startTimestamp = Date.now();
      this.rafId = requestAnimationFrame(() => this.tick());
    }
  }

  private tick() {
    if (this.finished || this.startTimestamp === undefined) return;
    const now = Date.now();
    const elapsed = this._elapsedTime + (now - this.startTimestamp);
    this.listeners.forEach(listener => listener(elapsed));
    if (elapsed >= this.delay) {
      this._elapsedTime = this.delay;
      this.finished = true;
      this.rafId = null;
      return;
    }
    this.rafId = requestAnimationFrame(() => this.tick());
  }

  finish() {
    this.pause();
    this.finished = true;
  }

  get isStarted(): boolean {
    return this.startTimestamp !== undefined;
  }

  get isPaused(): boolean {
    return this.startTimestamp === undefined && !this.finished;
  }

  get isFinished(): boolean {
    return this.finished;
  }

  get elapsedTime(): number {
    if (this.startTimestamp !== undefined) {
      return this._elapsedTime + (Date.now() - this.startTimestamp);
    }
    return this._elapsedTime;
  }
}
